import { cn } from "@/lib/utils";
import Link from "next/link";
import { ReactNode } from "react";

interface ServiceCardProps {
  // icon: ReactNode; // For the icon at the top
  title: string;
  description: string;
  className?: string;
  href: string
}

export const ServiceCard = ({  title, description, className,href }: ServiceCardProps) => {
  return (
    <div
      className={cn(
        " rounded-lg border bg-white p-5 shadow-sm hover:bg-[#002B4E] hover:text-white group cursor-pointer h-full",
        className
      )}
    >
      <Link href={href} className="flex flex-col items-start justify-start">
              {/* Icon */}
      {/* <div className="mb-4 text-4xl group-hover:text-white">{icon}</div> */}

      {/* Header */}
        <h3 className="mb-2 font-semibold text-[#002B4E] text-start text-lg min-h-12 whitespace-wrap group-hover:text-white w-full">{title}</h3>

      {/* Description */}
      {/* <div className="flex items-center mb-2" dangerouslySetInnerHTML={
        { __html: description }
      }/> */}
      
        <p className="text-base text-[#333333] text-start group-hover:text-white">{description}</p>
      </Link>

    </div>
  );
};
